import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Checkbox } from "@/components/ui/checkbox";
import { toast } from "sonner";

const BG = "https://static.prod-images.emergentagent.com/jobs/80f3ab0b-20a6-4c3d-8975-b8efebb3d425/images/602dc3bdb51faa502ac16412fbf2095d8bd37d49b9bf904293c29ed52c666da5.png";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [remember, setRemember] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await login(email, password, remember);
      toast.success("Accesso effettuato");
      if (!res.organization?.setup_completed) nav("/onboarding");
      else nav("/");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Credenziali non valide");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen grid grid-cols-1 lg:grid-cols-2 bg-white" data-testid="login-page">
      <div className="flex flex-col justify-center px-8 lg:px-20 py-12">
        <div className="max-w-md w-full mx-auto">
          <div className="font-display font-extrabold text-3xl tracking-tight text-slate-900">TCF<span className="text-slate-400">.</span>Platform</div>
          <div className="label-tag mt-1">Tax Control Framework — Italia</div>
          <h1 className="font-display text-4xl font-bold tracking-tight text-slate-900 mt-12">Bentornato.</h1>
          <p className="text-slate-600 mt-2">Accedi per gestire il tuo framework di controllo fiscale.</p>

          <form onSubmit={submit} className="mt-10 space-y-5" data-testid="login-form">
            <div>
              <Label className="label-tag" htmlFor="email">Email</Label>
              <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-2 rounded-sm border-slate-300" data-testid="login-email" />
            </div>
            <div>
              <Label className="label-tag" htmlFor="password">Password</Label>
              <Input id="password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="mt-2 rounded-sm border-slate-300" data-testid="login-password" />
            </div>
            <div className="flex items-center justify-between text-sm">
              <label className="flex items-center gap-2 cursor-pointer">
                <Checkbox checked={remember} onCheckedChange={setRemember} data-testid="login-remember" />
                <span className="text-slate-600">Ricordami per 30 giorni</span>
              </label>
              <span className="text-slate-500 text-xs">Password dimenticata?</span>
            </div>
            <Button type="submit" disabled={loading} className="w-full bg-slate-900 hover:bg-slate-800 rounded-sm h-11" data-testid="login-submit">
              {loading ? "Accesso…" : "Accedi"}
            </Button>
          </form>

          <div className="mt-8 text-sm text-slate-500">
            Non hai un account?{" "}
            <Link to="/register" className="text-slate-900 font-medium underline underline-offset-2" data-testid="goto-register">Crea organizzazione</Link>
          </div>

          <div className="mt-12 p-4 border border-slate-200 rounded-sm bg-slate-50 text-xs text-slate-600">
            <div className="label-tag mb-1">Account demo</div>
            admin@tcfplatform.it · Admin@2026
          </div>
        </div>
      </div>
      <div className="hidden lg:block relative">
        <img src={BG} alt="" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-slate-900/40" />
        <div className="absolute bottom-12 left-12 right-12 text-white">
          <div className="label-tag text-white/70">Cooperative Compliance — D.Lgs. 128/2015</div>
          <h2 className="font-display text-3xl font-bold mt-2 leading-tight">Mappa, controlla e certifica il tuo Tax Control Framework con rigore svizzero.</h2>
        </div>
      </div>
    </div>
  );
}
